import MultipleSelectChip from './MultipleSelectChip';

export default MultipleSelectChip;
